import isLast from "./isLast";

/**
 * Check whether should show add button
 * @param index entry index
 * @param listLength array length
 * @param isLastValid true if the last interval in the availability array is valid (the interval completely filled and contains no error)
 */
export default function shouldShowAdd(
  index: number,
  listLength: number,
  isLastValid: boolean,
) {
  if (isLastValid && isLast(index, listLength)) {
    return true;
  }
  return false;
}
